// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_6m-4";
export var collapsed = "_6m-1";
export var headerBar = "_6m-0";
export var leftHeaderContent = "_6m-3";
export var subjectContainer = "_6m-2";